var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000.000000pt",
    height: "320.000000pt",
    viewBox: "0 0 1000.000000 320.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,320.000000) scale(0.100000,-0.100000)",
    fill: "#2623db",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6383 3190 c-660 -64 -1104 -393 -1189 -882 -52 -295 55 -547 320 -752 103 -80 188 -131 401 -240 182 -93 286 -162 330 -221 60 -78 63 -190 7 -270 -80 -115 -249 -175 -490 -175 -251 1 -462 48 -705 157 -43 19 -80 33 -82 31 -5 -6 -157 -669 -153 -673 1 -2 49 -19 105 -39 262 -91 667 -140 963 -116 734 57 1192 412 1249 968 30 292 -72 518 -321 712 -92 71 -176 121 -475 283 -165 90 -244 147 -284 206 -28 41 -30 52 -27 108 5 79 41 134 118 181 106 64 172 77 375 76 208 0 312 -18 505 -85 63 -22 121 -41 129 -42 11 -2 32 74 88 313 40 173 71 320 69 325 -4 12 -168 65 -279 90 -182 42 -476 62 -654 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3123 c-21 -75 -28 -68 96 -98 339 -83 650 -200 759 -287 73 -58 77 -72 411 -1418 l314 -1265 429 -3 429 -2 674 1532 c370 842 675 1538 678 1545 4 11 -72 13 -420 13 l-425 0 -20 -47 c-11 -27 -205 -493 -432 -1038 -226 -545 -414 -993 -418 -997 -4 -4 -65 320 -135 720 -196 1109 -194 1099 -223 1156 -35 71 -106 139 -178 173 l-61 28 -737 3 c-698 2 -737 2 -741 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4157 3118 c-23 -96 -707 -3057 -707 -3062 0 -3 182 -6 404 -6 l404 0 6 24 c9 36 696 3007 703 3039 l6 27 -406 0 -405 0 -5 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8573 3119 c-68 -21 -130 -64 -175 -120 -18 -22 -292 -633 -668 -1490 l-639 -1454 417 -3 c229 -1 421 0 427 2 5 2 48 105 95 230 l85 226 522 0 521 0 10 -47 c6 -27 25 -122 42 -213 17 -91 33 -173 36 -182 5 -17 32 -18 381 -18 l375 0 -5 23 c-3 12 -137 684 -297 1492 -160 809 -295 1494 -301 1523 l-10 52 -377 -1 c-346 0 -382 -2 -439 -20z m345 -1395 c62 -312 111 -568 109 -571 -2 -2 -153 -2 -334 -1 l-330 3 216 567 c119 312 218 568 221 568 3 0 56 -255 118 -566z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f448691e81ad2ada1fb653b2ace063bc.svg";
export { ForwardRef as ReactComponent };